/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSpecialCriteriaByIdRequest
 */
export interface UpdateSpecialCriteriaByIdRequest {
    /**
     * 
     */
    enabled?: boolean;
    /**
     * 
     */
    facility_id?: string;
}

/**
 * Check if a given object implements the UpdateSpecialCriteriaByIdRequest interface.
 */
export function instanceOfUpdateSpecialCriteriaByIdRequest(value: object): value is UpdateSpecialCriteriaByIdRequest {
    return true;
}

export function UpdateSpecialCriteriaByIdRequestFromJSON(json: any): UpdateSpecialCriteriaByIdRequest {
    return UpdateSpecialCriteriaByIdRequestFromJSONTyped(json, false);
}

export function UpdateSpecialCriteriaByIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSpecialCriteriaByIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
    };
}

export function UpdateSpecialCriteriaByIdRequestToJSON(json: any): UpdateSpecialCriteriaByIdRequest {
    return UpdateSpecialCriteriaByIdRequestToJSONTyped(json, false);
}

export function UpdateSpecialCriteriaByIdRequestToJSONTyped(value?: UpdateSpecialCriteriaByIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'facility_id': value['facility_id'],
    };
}

